const useAllPackageUrl = () => {
  const createAllPackageUrl = (languageCode: string) => {
    const domain = getPackageDomain(languageCode);

    return `/${domain}`;
  };

  const getPackageDomain = (languageCode: string): string => {
    switch (languageCode) {
      case 'en':
        return 'winepackages';
      case 'de':
        return 'weinpaket';
      case 'pl':
        return 'pakiety-win';
      case 'hu':
      default:
        return 'borcsomagok';
    }
  };

  return { createAllPackageUrl };
};

export default useAllPackageUrl;
